const thousandsSeparator = (number: number, hasNoDecimal?: boolean) => {
	return hasNoDecimal ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').split('.')[0] : number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',')
}

export default thousandsSeparator